import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateBoolean, validateString } from '/imports/validators';
import { SmaPlant, SmaAccessToken as _SmaAccessToken } from '/server/integrations/sma';

export interface SmaMeter extends Omit<Doc, 'name'>, SmaPlant {
  _id: string;
  meterId: string;
  accessTokenId: string;
}
export type Model = SmaMeter;

export const SmaMeters = new Mongo.Collection<SmaMeter>('smaMeters');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: SmaMeters,
  editableFields: ['active'],
  listMethod: DeclareMethod<ListMethodArg<SmaMeter>, ListMethodResponse<SmaMeter, Refs>>('listSmaMeters'),
  getMethod: DeclareMethod<string, GetMethodResponse<SmaMeter, Refs>>('getSmaMeter'),
  createMethod: DeclareMethod<Partial<SmaMeter>, string>('createSmaMeter'),
  updateMethod: DeclareMethod<Partial<SmaMeter>, string>('updateSmaMeter'),
  deleteMethod: DeclareMethod<string>('deleteSmaMeter'),
  pathPrefix: '/sma-meters',
  asString: (document) => document.name || document.plantId || document._id,
  modelName: 'SMA',
  pluralName: 'SMA',
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { name: new RegExp(search, 'gi') },
        { plantId: new RegExp(search, 'gi') },
      ]
    };
  },
  validate: async (document: Partial<SmaMeter>) => {
    const errors: { [key: string]: string[] } = {};
    validateBoolean(errors, document, 'active');
    validateString(errors, document, 'meterId', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await SmaMeters.createIndexAsync({ meterId: 1 });
  await SmaMeters.createIndexAsync({ accessTokenId: 1 });
});

export interface SmaAccessToken extends _SmaAccessToken {
  _id: string;
  orgId: string;
  username: string;
}

export const SmaAccessTokens = new Mongo.Collection<SmaAccessToken>('smaAccessTokens');

export const handleSmaAccessTokenCode = DeclareMethod<{ code: string, orgId: string, username: string }>('handleSmaAccessTokenCode');
export const getSmaAccessTokensForOrg = DeclareMethod<string, SmaAccessToken[]>('getSmaAccessTokensForOrg');
export const pullSmaPlantsForToken = DeclareMethod<string, { numPlants: number, numCreated: number }>('pullSmaPlantsForToken');

Meteor.isServer && Meteor.startup(async () => {
  await SmaAccessTokens.createIndexAsync({ orgId: 1 });
});
